/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-renew': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M7.5 6.25H4.237A6.875 6.875 0 0116.875 10h1.25A8.125 8.125 0 003.75 4.8V2.5H2.5v5h5V6.25zm5 7.5h3.262A6.875 6.875 0 013.125 10h-1.25a8.125 8.125 0 0014.375 5.2v2.3h1.25v-5h-5v1.25z"/>'
  }
})
